import { parseMarkdownTable } from "@/lib/message-bubble-utils";
import { useMemo } from "react";

export const useExtractTableFromLlmMessage = (message: string) => useMemo(() => {
    const tableRegex = /(\|.+\|[\r\n]+\|[-| ]+\|[\r\n]+(\|.+\|[\r\n]*)*)/g;
    const textParts: Array<{ text: string; index: number }> = [];
    const tables: Array<{ headers: string[]; rows: string[][]; index: number }> = [];

    let lastIndex = 0;
    let match;

    // Remove artifact button placeholders from content before processing
    const cleanContent = message.replace(/\[\[ARTIFACT_BTN_[^\]]+\]\]/g, '');

    while ((match = tableRegex.exec(cleanContent)) !== null) {
      if (match.index > lastIndex) {
        textParts.push({
          text: cleanContent.slice(lastIndex, match.index),
          index: lastIndex,
        });
      }

      const { headers, rows } = parseMarkdownTable(match[0]);
      tables.push({ headers, rows, index: match.index });

      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < cleanContent.length) {
      textParts.push({
        text: cleanContent.slice(lastIndex),
        index: lastIndex,
      });
    }

    return { textParts, tables };
  }, [message]);